export function isValueEmpty(val) {
  return val === void 0 || val === null || val === "";
}
